import React from 'react';

import { useToggle } from '../../../hooks/useToggle';

const CheckboxForSettings = props => {

    const {
        value,
        settingName,
        handleInputChange
    } = props;

    const [ isChecked, toggleChecking ] = useToggle(value);

    const handle = e => {
        toggleChecking();
        handleInputChange(e);
    };

    return (
        <input
            type='checkbox'
            checked={isChecked}
            name={settingName}
            onChange={e => handle(e)}
        />
    );
};

export default CheckboxForSettings;